import * as React from 'react';
import * as moment from 'moment';
import { Link } from 'react-router-dom';

const ListPost = (props) => {
	return (
		<div className="post-box">
			<div className="row">
				<div className="col-sm-5">
					<div className="teaser">
						<Link to={`/post/${props.category_slug}/${props.item.post_id}/${props.item.post_name}`}>
							<span className="imgPost">
								<img src={require('../../img/img-maskPost370x250.png')}
								     style={{ background: `url(${props.item.post_thumbnail.link}) no-repeat center center/cover` }}/>
							</span>
						</Link>
					</div>
				</div>
				<div className="col-sm-7">
					<div className="meta">
						<div className="entry-title">
							<Link to={`/post/${props.category_slug}/${props.item.post_id}/${props.item.post_name}`}>
								<h2><span>{props.item.post_title}</span></h2>
							</Link>
						</div>
						{/*<div className="counters">
							<span className="time">
								<time className="timeago">{moment.unix(props.item.post_modified.timestamp).fromNow()}</time>
							</span>
						</div>*/}
						<div className="post-box-excerpt">
							<p>{props.item.post_excerpt}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ListPost;



// WEBPACK FOOTER //
// ./src/containers/component/ListPost.tsx